"use client";

import { AuroraHero } from "./AuroraHero";
import { SpotlightHero } from "./SpotlightHero";
import { MinimalHero } from "./MinimalHero";
import { GlassHero } from "./GlassHero";
import { OrbitHero } from "./OrbitHero";
import { FluxHero } from "./FluxHero";
import { resolveHeroTheme } from "./types";
import type { HeroContent } from "./types";
import type { HeroThemeId } from "@/lib/types";

type Props = {
  theme?: HeroThemeId | string;
  content: HeroContent;
};

export function HeroThemed({ theme, content }: Props) {
  const id = resolveHeroTheme(theme);
  switch (id) {
    case "spotlight":
      return <SpotlightHero content={content} />;
    case "glass":
      return <GlassHero content={content} />;
    case "orbit":
      return <OrbitHero content={content} />;
    case "flux":
      return <FluxHero content={content} />;
    case "minimal":
      return <MinimalHero content={content} />;
    case "aurora":
    default:
      return <AuroraHero content={content} />;
  }
}
